<template>
  <v-container fluid>
    <SidebarNavigation />

    <v-card class="pa-2">
      <!-- FILTER -->
      <v-row dense align="center">
        <!-- Tahun -->
        <v-col cols="2">
          <v-select
            v-model="pagination.year"
            :items="yearOptions"
            label="Tahun"
            prepend-inner-icon="mdi-calendar"
            dense
            outlined
            hide-details
            clearable
            @change="onYearChange()"
          />
        </v-col>

        <!-- Worksheet -->
        <v-col cols="5">
          <v-autocomplete
            v-model="pagination.worksheet"
            :items="listWorksheet"
            label="Kertas Kerja Budget"
            prepend-inner-icon="mdi-file-document-outline"
            :item-text="(item) => `${item.worksheet_name}`"
            item-value="id"
            outlined
            dense
            clearable
            hide-details
            @change="onWorksheetChange()"
          />
        </v-col>
        <!-- site -->
        <v-col cols="2">
          <v-select
            v-model="pagination.site_id"
            :items="listSite"
            label="Lokasi Kerja"
            prepend-inner-icon="mdi-office-building-outline"
            dense
            outlined
            clearable
            hide-details
            item-text="dc_code"
            item-value="mst_site_id"
            @change="onsiteChange()"
          />
        </v-col>

        <!-- corporate -->
        <v-col cols="3">
          <v-select
            v-model="pagination.corporate_id"
            :items="listCorporate"
            label="Perusahaan"
            prepend-inner-icon="mdi-office-building-outline"
            dense
            outlined
            clearable
            hide-details
            item-text="mst_corporate_name"
            item-value="mst_corporate_id"
            @change="oncorporateChange()"
          />
        </v-col>
      </v-row>

      <!-- SEARCH & BUTTON -->
      <v-row dense align="center" class="mt-1">
        <!-- Search -->
        <!-- <v-col cols="12" sm="8" md="6" lg="4">
          <v-text-field
            v-model="pagination.search"
            label="Cari Budget..."
            prepend-inner-icon="mdi-magnify"
            dense
            outlined
            clearable
            hide-details
            @input="debouncedSearch"
          />
        </v-col> -->

        <!-- Button -->
        <!-- <v-col cols="12" sm="4" md="6" lg="8">
          <v-btn
            color="primary"
            class="text-none px-5"
            elevation="2"
            @click="exportToExcel()"
          >
            <v-icon left small>mdi-file-excel</v-icon>
            Export Excel
          </v-btn>
        </v-col> -->
      </v-row>

      <!-- TABLE -->
      <v-row>
        <v-col>
          <div class="table-wrapper">
            <v-data-table
              mobile-breakpoint="0"
              fixed-header
              dense
              class="elevation-5"
              :headers="tableHeaders"
              :items="List"
              :loading="isLoading"
              item-key="id"
              hide-default-footer
            >
              <template v-slot:body="{ items }">
                <tbody>
                  <tr v-for="(item, index) in items" :key="index">
                    <td class="text-start">
                      <v-btn
                        small
                        variant="text"
                        color="primary"
                        class="text-start"
                        v-if="item.mst_division_name"
                      >
                        {{ item.mst_division_name }}
                      </v-btn>
                    </td>

                    <td
                      class="text-start"
                      :class="{
                        'grand-total-row': item.part
                          ?.toLowerCase()
                          .includes('grand total'),
                      }"
                    >
                      <div>
                        {{ item.part }}
                      </div>
                    </td>

                    <td
                      v-for="month in months"
                      :key="month.key"
                      class="text-end"
                      :class="{
                        'grand-total-row': item.part
                          ?.toLowerCase()
                          .includes('grand total'),
                      }"
                    >
                      <div
                        class="clickable-cell"
                        @click="
                          fetchEachItemByMonth(
                            pagination.year,
                            item,
                            month.id,
                            month.id,
                            item.part,
                            'all',
                          )
                        "
                      >
                        {{
                          formatRupiahUtil(
                            item[`${month.key}_total_price`] || 0,
                          )
                        }}
                      </div>
                    </td>

                    <td
                      class="text-end"
                      :class="{
                        'grand-total-row': item.part
                          ?.toLowerCase()
                          .includes('grand total'),
                      }"
                    >
                      <div class="d-flex flex-column align-end">
                        <span
                          class="clickable-cell"
                          @click="
                            fetchEachItemByMonth(
                              pagination.year,
                              item,
                              1,
                              12,
                              item.part,
                              'all',
                            )
                          "
                        >
                          {{ formatRupiahUtil(item.yearly_total_price || 0) }}
                        </span>

                        <span
                          @click="
                            fetchEachItemByMonth(
                              pagination.year,
                              item,
                              1,
                              12,
                              item.part,
                              1,
                            )
                          "
                          v-if="item.count_is_new > 0"
                          class="font-weight-bold clickable-cell"
                          style="font-size: 10px; color: #4caf50"
                        >
                          +{{ item.count_is_new }} New item
                        </span>
                      </div>
                    </td>

                    <td
                      class="text-end"
                      :class="{
                        'grand-total-row': item.part
                          ?.toLowerCase()
                          .includes('grand total'),
                      }"
                    >
                      <div
                        class="clickable-cell"
                        @click="
                          openDialogRealizationSuccessByMonth(
                            item,
                            '1',
                            Number(cut_off_yesterday),
                          )
                        "
                      >
                        {{
                          formatRupiahUtil(
                            item.yearly_total_price_realization || 0,
                          )
                        }}
                      </div>
                    </td>

                    <td
                      class="text-right"
                      :class="{
                        'grand-total-row': item.part
                          ?.toLowerCase()
                          .includes('grand total'),
                      }"
                    >
                      <div
                        class="clickable-cell"
                        @click="
                          fetchEachItemByMonth(
                            pagination.year - 1,
                            item,
                            Number(cut_off_yesterday) + 1,
                            12,
                            item.part,
                            'all',
                          )
                        "
                      >
                        {{
                          formatRupiahUtil(item.yearly_total_price_prev || 0)
                        }}
                      </div>
                    </td>

                    <td
                      class="text-end"
                      :class="{
                        'grand-total-row': item.part
                          ?.toLowerCase()
                          .includes('grand total'),
                      }"
                    >
                      <div>
                        {{
                          formatRupiahUtil(
                            item.yearly_total_price_realization_yearly_total_price_prev,
                          )
                        }}
                      </div>
                    </td>

                    <td
                      class="text-end"
                      :class="{
                        'grand-total-row': item.part
                          ?.toLowerCase()
                          .includes('grand total'),
                      }"
                    >
                      <div class="d-flex justify-end align-center">
                        <v-icon
                          v-if="getTrend(item.naik_turun) === 'up'"
                          color="green"
                          size="16"
                          class="mr-1"
                        >
                          mdi-arrow-up-bold
                        </v-icon>

                        <v-icon
                          v-else-if="getTrend(item.naik_turun) === 'down'"
                          color="red"
                          size="16"
                          class="mr-1"
                        >
                          mdi-arrow-down-bold
                        </v-icon>

                        {{ formatRupiahUtil(item.naik_turun ?? 0) }}
                      </div>
                    </td>

                    <td
                      class="text-end"
                      :class="{
                        'grand-total-row': item.part
                          ?.toLowerCase()
                          .includes('grand total'),
                      }"
                    >
                      <div class="d-flex justify-end align-center">
                        <v-icon
                          v-if="getTrend(item.naik_turun_percent) === 'up'"
                          color="green"
                          size="16"
                          class="mr-1"
                        >
                          mdi-arrow-up-bold
                        </v-icon>

                        <v-icon
                          v-else-if="
                            getTrend(item.naik_turun_percent) === 'down'
                          "
                          color="red"
                          size="16"
                          class="mr-1"
                        >
                          mdi-arrow-down-bold
                        </v-icon>

                        {{ item.naik_turun_percent ?? 0 }}
                      </div>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-data-table>
          </div>
        </v-col>
      </v-row>
    </v-card>

    <!-- each item by month-->
    <v-dialog v-model="isDialogEachItemByMonth">
      <v-card class="rounded-0">
        <!-- HEADER -->
        <div class="dialog-header">
          <div class="px-6 pt-5 pb-4 d-flex justify-space-between align-start">
            <div>
              <div class="text-subtitle-1 font-weight-medium mb-1">
                Budget {{ selectedItem?.fiscalYear }} (Bulan
                {{
                  selectedItem?.monthStart === selectedItem?.monthEnd
                    ? selectedItem?.monthStart
                    : `${selectedItem?.monthStart} - ${selectedItem?.monthEnd}`
                }})
              </div>
            </div>

            <!-- CLOSE -->
            <v-tooltip text="Tutup Modal" location="bottom" open-delay="200">
              <template #activator="{ props }">
                <v-btn
                  v-bind="props"
                  icon
                  variant="text"
                  size="small"
                  color="grey-darken-1"
                  @click="isDialogEachItemByMonth = false"
                >
                  <v-icon size="18">mdi-close</v-icon>
                </v-btn>
              </template>
            </v-tooltip>
          </div>

          <!-- ACTION BAR -->
          <div
            class="px-6 pb-4 d-flex align-center justify-space-between flex-wrap ga-4"
          >
            <div class="d-flex align-center ga-3 flex-wrap">
              <v-btn-toggle
                v-model="showModeByMonth"
                mandatory
                color="primary"
                density="comfortable"
                divided
              >
                <v-btn value="qty">
                  <v-icon start size="18">mdi-counter</v-icon>
                  Qty
                </v-btn>

                <v-btn value="values">
                  <v-icon start size="18">mdi-cash</v-icon>
                  Value
                </v-btn>

                <v-btn value="all">
                  <v-icon start size="18">mdi-view-grid</v-icon>
                  Semua
                </v-btn>
              </v-btn-toggle>

              <v-text-field
                v-model="searchDetail"
                placeholder="Cari item..."
                prepend-inner-icon="mdi-magnify"
                hide-details
                density="compact"
                variant="outlined"
                clearable
                class="mx-3"
                style="min-width: 280px; max-width: 350px"
              />
            </div>
          </div>

          <v-divider />
        </div>
        <v-data-table
          class="budget-table"
          fixed-header
          density="compact"
          :headers="tableHeadersEachItemFilteredByMonth"
          :items="filteredListDetailByMonth"
          :loading="isLoadingByMonth"
          item-key="item_id"
          :items-per-page="5"
        >
          <template #body="{ items }">
            <tbody>
              <tr
                v-for="(item, index) in items"
                :key="index"
                :class="{
                  'new-item-row': Number(item.is_new) === 1,
                }"
              >
                <!-- REALIZATION
                <td class="text-center sticky-realization">
                  <v-btn
                    v-if="Number(item.is_new) !== 1"
                    icon
                    size="x-small"
                    color="primary"
                    variant="text"
                    @click="openDialogRealizationByWorksheetId(item)"
                  >
                    <v-icon size="16"> mdi-file-eye </v-icon>
                  </v-btn>
                </td> -->

                <td class="text-center">{{ item.item_name }}</td>
                <td class="text-center">{{ item.material_name }}</td>
                <td class="text-center">{{ item.spesification }}</td>
                <td class="text-center">{{ item.uom_name }}</td>
                <td class="text-center">{{ item.frekuensi }}</td>

                <td
                  class="text-right"
                  v-if="showModeByMonth === 'qty' || showModeByMonth === 'all'"
                >
                  {{ formatNumberRibuan(getItemTotalQty(item)) }}
                </td>

                <td
                  class="text-right"
                  v-if="
                    showModeByMonth === 'values' || showModeByMonth === 'all'
                  "
                >
                  {{ formatRupiahUtil(getItemTotalPrice(item)) }}
                </td>

                <!-- <td class="text-center">{{ item.month_name }}</td> -->

                <td class="text-center">{{ item.part }}</td>
                <td class="text-center">{{ item.mst_division_name }}</td>
                <td class="text-center">{{ item.worksheet_budget_name }}</td>
                <td class="text-center">{{ item.dc_code }}</td>
                <td class="text-center">{{ item.mst_corporate_name }}</td>
              </tr>
            </tbody>
          </template>
        </v-data-table>
      </v-card>
    </v-dialog>

    <!-- realization by month -->
    <v-dialog v-model="isDialogOpenRealizationByMonth" max-width="1200px">
      <v-card class="rounded-xl">
        <!-- HEADER -->
        <v-card-title class="d-flex justify-space-between align-center">
          <div>
            <div class="text-h6 font-weight-bold">
              Realisasi {{ this.pagination.year - 1 }} (Bulan 1 -
              {{ Number(this.cut_off_yesterday) }})
            </div>
          </div>

          <div class="d-flex align-center ga-2">
            <v-tooltip text="Tutup Modal" location="bottom" open-delay="200">
              <template #activator="{ props }">
                <v-btn
                  v-bind="props"
                  icon
                  variant="text"
                  size="small"
                  @click="isDialogOpenRealizationByMonth = false"
                >
                  <v-icon size="18">mdi-close</v-icon>
                </v-btn>
              </template>
            </v-tooltip>
          </div>
        </v-card-title>

        <v-divider />

        <!-- CONTENT -->
        <v-data-table
          dense
          fixed-header
          class="elevation-1"
          :headers="tableHeadersRealizationByMonth"
          :items="listRealizationSuccessByMonth"
          item-key="id"
          :items-per-page="5"
          :footer-props="{
            itemsPerPageOptions: [5, 10, 20, -1],
          }"
        >
          <template v-slot:body="{ items }">
            <tbody>
              <tr v-for="item in items" :key="item.id">
                <td style="min-width: 180px">
                  {{ item.account || "-" }}
                </td>

                <td>
                  {{ item.transaksi_date || "-" }}
                </td>

                <td style="min-width: 220px">
                  {{ item.item_name || "-" }}
                </td>

                <td style="min-width: 220px">
                  {{ item.material_name || "-" }}
                </td>

                <td style="min-width: 220px">
                  {{ item.spesification || "-" }}
                </td>

                <td class="text-center">
                  {{ item.qty || 0 }}
                </td>

                <td>
                  {{ item.uom_name || "-" }}
                </td>

                <td style="min-width: 180px">
                  {{ item.dc_code || "-" }}
                </td>

                <td style="min-width: 180px">
                  {{ item.mst_corporate_name || "-" }}
                </td>

                <td style="min-width: 220px">
                  {{ item.supplier_name || "-" }}
                </td>

                <td style="min-width: 220px">
                  {{ item.departement_name || "-" }}
                </td>

                <td class="text-right">
                  {{ formatRupiahUtil(item.debit || 0) }}
                </td>

                <td class="text-right">
                  {{ formatRupiahUtil(item.credit || 0) }}
                </td>

                <td class="text-center sticky-excel">
                  <v-btn
                    v-if="item.object_excel"
                    icon
                    size="x-small"
                    color="primary"
                    variant="text"
                    @click="openDialogExcel(item.object_excel)"
                  >
                    <v-icon size="16">mdi-file-eye</v-icon>
                  </v-btn>
                </td>
              </tr>
            </tbody>
          </template>
        </v-data-table>

        <v-divider />

        <!-- ACTION -->
        <v-card-actions class="pa-4">
          <v-spacer />

          <v-btn
            variant="outlined"
            color="secondary"
            @click="isDialogOpenRealizationByMonth = false"
          >
            Tutup
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- dialog excel referensi -->
    <v-dialog v-model="isDialogExcel" max-width="500px">
      <v-card class="rounded-lg">
        <v-card-title
          class="d-flex justify-space-between align-center px-6 py-4"
        >
          <span class="text-subtitle-1 font-weight-medium">
            Realisasi Kartu Buku Besar (Excel)
          </span>

          <v-tooltip text="Tutup Modal" location="bottom" open-delay="200">
            <template #activator="{ props }">
              <v-btn
                v-bind="props"
                icon
                variant="text"
                size="small"
                color="grey-darken-1"
                @click="isDialogExcel = false"
              >
                <v-icon size="18">mdi-close</v-icon>
              </v-btn>
            </template>
          </v-tooltip>
        </v-card-title>

        <v-divider />

        <v-card-text v-if="selectedRealizationExcel" class="pt-4">
          <v-row dense>
            <v-col cols="6">
              <div class="text-caption text-medium-emphasis">K2</div>
              <div class="text-body-2">
                {{ selectedRealizationExcel.k2 || "-" }}
              </div>
            </v-col>

            <v-col cols="6">
              <div class="text-caption text-medium-emphasis">No. Account</div>
              <div class="text-body-2">
                {{ selectedRealizationExcel.no_account || "-" }}
              </div>
            </v-col>

            <v-col cols="6">
              <div class="text-caption text-medium-emphasis">Tanggal</div>
              <div class="text-body-2">
                {{ selectedRealizationExcel.date || "-" }}
              </div>
            </v-col>

            <v-col cols="6">
              <div class="text-caption text-medium-emphasis">Deskripsi</div>
              <div class="text-body-2">
                {{ selectedRealizationExcel.description || "-" }}
              </div>
            </v-col>

            <v-col cols="6">
              <div class="text-caption text-medium-emphasis">Debit</div>
              <div class="text-body-2">
                {{ selectedRealizationExcel.debit || "-" }}
              </div>
            </v-col>

            <v-col cols="6">
              <div class="text-caption text-medium-emphasis">Credit</div>
              <div class="text-body-2">
                {{ selectedRealizationExcel.credit || "-" }}
              </div>
            </v-col>

            <!-- <v-col cols="12">
              <div class="text-caption text-medium-emphasis">Ending</div>
              <div class="text-body-2">
                {{ selectedRealizationExcel.ending || "-" }}
              </div>
            </v-col> -->
          </v-row>
        </v-card-text>

        <v-divider />

        <v-card-actions class="pa-4">
          <v-spacer />
          <v-btn
            variant="tonal"
            color="grey-darken-1"
            @click="isDialogExcel = false"
          >
            Tutup
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Snackbar Notifications -->
    <snackbarMessage />
  </v-container>
</template>

<script>
import api from "@/utils/api";
import SidebarNavigation from "@/components/SidebarNavigation.vue";
import snackbarMessage from "@/components/snackbarMessage.vue";
import { formatNumberRibuan, formatRupiahUtil } from "@/utils/formatter";
import store from "@/store";
import {
  getCurrentYearRange,
  // getCurrentYear,
  dateFormatDmy,
} from "@/utils/date";
import exceljs from "exceljs";
import { saveAs } from "file-saver";

export default {
  components: {
    SidebarNavigation,
    snackbarMessage,
  },
  data() {
    const currentYear = new Date().getFullYear();

    return {
      searchDetail: "",

      showMode: "qty",
      showModeByMonth: "qty",
      months: [
        { id: 1, key: "january", label: "Jan" },
        { id: 2, key: "february", label: "Feb" },
        { id: 3, key: "march", label: "Mar" },
        { id: 4, key: "april", label: "Apr" },
        { id: 5, key: "may", label: "May" },
        { id: 6, key: "june", label: "Jun" },
        { id: 7, key: "july", label: "Jul" },
        { id: 8, key: "august", label: "Aug" },
        { id: 9, key: "september", label: "Sep" },
        { id: 10, key: "october", label: "Oct" },
        { id: 11, key: "november", label: "Nov" },
        { id: 12, key: "december", label: "Dec" },
      ],

      tableHeadersEachItemByMonth: [
        // {
        //   text: "Realisasi",
        //   align: "center",
        //   value: "realization",
        //   width: "80px",
        // },

        {
          text: "Item",
          align: "center",
          value: "item_name",
          width: "130px",
        },
        {
          text: "Material",
          align: "center",
          value: "material_name",
          width: "130px",
        },
        { text: "Spesifikasi", align: "center", value: "spesification" },

        {
          text: "Satuan",
          align: "center",
          value: "uom_name",
          width: "120px",
        },

        {
          text: "Frekuensi",
          align: "center",
          value: "frekuensi",
          width: "120px",
        },

        {
          text: "Total Qty",
          value: "total_qty",
          align: "end",
          type: "qty",
        },

        {
          text: "Total Values",
          value: "total_values",
          align: "end",
          type: "values",
        },

        // {
        //   text: "Bulan",
        //   align: "center",
        //   value: "month_name",
        //   width: "130px",
        // },

        {
          text: "Bagian",
          align: "center",
          value: "part",
          width: "130px",
        },
        {
          text: "Departemen",
          align: "center",
          value: "mst_division_name",
          width: "130px",
        },
        {
          text: "Kertas Kerja Budget",
          align: "center",
          value: "worksheet_budget_name",
          width: "130px",
        },
        {
          text: "Lokasi Kerja",
          align: "center",
          value: "dc_code",
          width: "130px",
        },
        {
          text: "Perusahaan",
          align: "center",
          value: "mst_corporate_name",
          width: "130px",
        },
      ],

      tableHeadersRealizationByMonth: [
        { text: "Account", align: "center", value: "account" },
        { text: "Tanggal", align: "center", value: "transaksi_date" },
        { text: "Item", align: "center", value: "item_name" },
        { text: "Material", align: "center", value: "material_name" },
        { text: "Spesifikasi", align: "center", value: "spesification" },
        { text: "qty", align: "center", value: "qty", width: "100px" },
        { text: "Satuan", align: "center", value: "uom_name" },
        { text: "Lokasi Kerja", align: "center", value: "dc_code" },
        { text: "Perusahaan", align: "center", value: "corporate_name" },
        { text: "Supplier", align: "center", value: "supplier_name" },
        { text: "Departemen", align: "center", value: "departement_name" },
        { text: "Debit", align: "center", value: "debit" },
        { text: "Kredit", align: "center", value: "credit", width: "100px" },
        {
          text: "",
          align: "center",
          value: "object_excel",
          width: "60px",
          class: "sticky-excel",
        },
      ],
      currentYear: currentYear,
      currentYearRange: getCurrentYearRange(),
      yearOptions: Array.from({ length: 6 }, (_, i) => currentYear + i),
      awsObjectUrl: process.env.VUE_APP_AWS_OBJECT_URL,
      awsPath: process.env.VUE_APP_AWS_PATH,
      tab: 1,
      tabItems: ["Budget"],
      pagination: {
        page: 1,
        itemsPerPage: 10,
        sortBy: "id",
        sortDesc: false,
        startMenu: false,
        endMenu: false,
        startDate: getCurrentYearRange().start,
        endDate: getCurrentYearRange().end,
        search: "",
        status: "success",
        worksheet: "all",
        departement_id: "all",
        year: currentYear + 1,
        item_id: null,
        searchItem: null,
        site_id: "all",
        corporate_id: "all",
      },
      total: 0,
      totalEachWorksheet: 0,
      List: [],
      listCorporate: [],
      listRealizationSuccessByMonth: [],
      listDetail: [],
      listDetailByMonth: [],
      listPf: [],
      listParameter: [],
      listItem: [],
      listCoa: [],
      listdepartement: [],
      listSite: [],
      listSupplier: [],
      listUom: [],
      listWorksheet: [],
      ListShowQtyValues: ["qty", "values"],
      isLoading: false,
      isLoadingByMonth: false,
      isDialogEachItemByMonth: false,
      isDialogOpenRealizationByMonth: false,
      isDialogExcel: false,
      selectedItem: null,
      selectedItemEachItemByMonth: null,
      selectedRealizationExcel: {},
      cut_off: null,
      cut_off_yesterday: null,
    };
  },
  methods: {
    formatNumberRibuan,
    formatRupiahUtil,

    async fetch() {
      // Tampilkan loading
      store.dispatch("showLoading");
      this.isLoading = true;
      const query = this.$route.query;

      // console.log(this.cut_off);

      const params = {
        // worksheet: query.worksheet || this.pagination.worksheet,
        year: query.year || this.pagination.year,
        cutOff: this.cut_off,
        cutOffYesterday: this.cut_off_yesterday,
        worksheet: this.pagination.worksheet,
        siteId: this.pagination.site_id,
        corporateId: this.pagination.corporate_id,
      };

      await api
        .get("/report", { params })
        .then(({ data }) => {
          // console.log(data.data);
          this.List = data.data;
          this.total = data.data.length;
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          this.isLoading = false;
          // Sembunyikan loading setelah request selesai
          store.dispatch("hideLoading");
        });
    },

    async fetchEachItemByMonth(
      fiscalYear,
      item,
      monthStart,
      monthEnd,
      part,
      isNew,
    ) {
      // console.log(fiscalYear);
      this.selectedItem = item;
      this.selectedItem.monthStart = monthStart;
      this.selectedItem.monthEnd = monthEnd;
      this.selectedItem.fiscalYear = fiscalYear;
      // Tampilkan loading
      this.listDetailByMonth = [];
      store.dispatch("showLoading");
      this.isLoading = true;

      await api
        .get(
          `/report/budget-each-item/${
            item.mst_division_id || "all"
          }/${fiscalYear}/${this.pagination.worksheet}/${
            this.pagination.site_id
          }/${this.pagination.corporate_id}/${monthStart}/${monthEnd}/${part
            .replace(/^grand total\s*/i, "")
            .trim()}/${isNew}`,
        )
        .then(({ data }) => {
          // console.log(data);
          this.listDetailByMonth = data.data || [];

          // console.log(this.listDetailByMonth);

          // console.log(this.listDetailByMonth);
          this.isDialogEachItemByMonth = true;
        })
        .catch((error) => {
          console.error("Error fetching suggestion:", error);
        })
        .finally(() => {
          this.isLoading = false;
          // Sembunyikan loading setelah request selesai
          store.dispatch("hideLoading");
        });
    },

    async fetchPurchaseFrequency() {
      api
        .get("/pf")
        .then(({ data }) => {
          this.listPf = data.data.data;
          // console.log(this.listPf);
        })
        .catch((error) => {
          console.error("Error fetching item:", error);
        })
        .finally(() => {
          store.dispatch("hideLoading");
        });
    },
    async fetchParameter() {
      api
        .get("/parameters")
        .then(({ data }) => {
          this.listParameter = data.data.data;
          this.cut_off =
            this.listParameter.find(
              (e) =>
                e.fiscal_year == this.pagination.year &&
                e.name.toLowerCase() === "cut_off",
            )?.value || 0;

          this.cut_off_yesterday =
            this.listParameter.find(
              (e) =>
                e.fiscal_year == this.pagination.year - 1 &&
                e.name.toLowerCase() === "cut_off",
            )?.value || 0;

          // console.log(this.cut_off);
          // console.log(this.cut_off_yesterday);
        })
        .catch((error) => {
          console.error("Error fetching item:", error);
        })
        .finally(() => {
          store.dispatch("hideLoading");
        });
    },
    async fetchItem(item = null) {
      api
        .get("/items", { search: item?.searchItem })
        .then(({ data }) => {
          this.listItem = data.data.data;
          // console.log(this.listItem);
        })
        .catch((error) => {
          console.error("Error fetching item:", error);
        })
        .finally(() => {
          store.dispatch("hideLoading");
        });
    },
    async fetchCoa(item = null) {
      api
        .get("/coa", { search: item?.searchCoa })
        .then(({ data }) => {
          this.listCoa = data.data.data;
        })
        .catch((error) => {
          console.error("Error fetching Coa:", error);
        })
        .finally(() => {
          store.dispatch("hideLoading");
        });
    },
    async fetchdepartement(item = null) {
      api
        .get("/divisions", { search: item?.searchdepartement })
        .then(({ data }) => {
          this.listdepartement = data.data.data;
        })
        .catch((error) => {
          console.error("Error fetching departement:", error);
        })
        .finally(() => {
          store.dispatch("hideLoading");
        });
    },
    async fetchSite(item = null) {
      try {
        const { data } = await api.get("/sites", {
          params: {
            search: item?.searchSite || "",
            corporateId: 2,
          },
        });

        const sites = (data.data.data || []).filter(
          (e) => ![1163, 1164, 1165, 1395, 4].includes(e.mst_site_id),
        );

        this.listSite = [
          {
            mst_site_id: "all",
            dc_code: "All",
          },
          ...sites,
        ];

        this.listSiteCreate = sites;
      } catch (error) {
        console.error("Error fetching site:", error);

        store.dispatch("triggerSnackbar", {
          message: error?.response?.data?.message || "Failed fetch site",
          isSuccess: false,
        });
      } finally {
        store.dispatch("hideLoading");
      }
    },

    async fetchCorporate() {
      try {
        const { data } = await api.get("/corporates", {
          params: {
            category: "GROUP",
          },
        });

        const corporates = (data?.data?.data || []).filter((e) =>
          e.mst_corporate_name?.toLowerCase().includes("fastana"),
        );

        this.listCorporate = [
          {
            mst_corporate_id: "all",
            mst_corporate_name: "All",
          },
          ...corporates,
        ];

        this.listCorporateCreate = corporates;
      } catch (error) {
        store.dispatch("triggerSnackbar", {
          message: error?.response?.data?.message || "Failed fetch corporate",
          isSuccess: false,
        });
      } finally {
        store.dispatch("hideLoading");
      }
    },
    async fetchSupplier(item = null) {
      api
        .get("/supplier", { search: item?.searchSupplier })
        .then(({ data }) => {
          this.listSupplier = data.data.data;
        })
        .catch((error) => {
          console.error("Error fetching supplier:", error);
        })
        .finally(() => {
          store.dispatch("hideLoading");
        });
    },
    async fetchUom(item = null) {
      api
        .get("/uom", { search: item?.searchUom })
        .then(({ data }) => {
          this.listUom = data.data.data;
        })
        .catch((error) => {
          console.error("Error fetching Uom:", error);
        })
        .finally(() => {
          store.dispatch("hideLoading");
        });
    },
    async fetchWorksheet() {
      api
        .get("/wb")
        .then(({ data }) => {
          const worksheets = data.data.data;

          this.listWorksheet = [
            {
              id: "all",
              worksheet_name: "All",
              account: "All",
            },
            ...worksheets,
          ];
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          store.dispatch("hideLoading");
        });
    },

    async openDialogRealizationSuccessByMonth(item, monthStart, monthEnd) {
      this.listRealizationSuccessByMonth = [];
      store.dispatch("showLoading");
      this.isLoading = true;

      const params = {
        worksheetId: this.pagination.worksheet,
        itemId: "all",
        materialId: "all",
        spesification: "all",
        uomId: "all",
        departementId: item.departement_id || "all",
        siteId: this.pagination.site_id,
        corporateId: this.pagination.corporate_id,
        fiscalYear: this.pagination.year - 1,
        monthStart: monthStart,
        monthEnd: monthEnd,
        part: item.part.replace(/^grand total\s*/i, "").trim(),
        isNew: "all",
      };

      await api
        .get("/realization/forbudget-bymonth", {
          params,
        })
        .then(({ data }) => {
          // console.log(data);
          this.listRealizationSuccessByMonth = data.data || [];
          this.isDialogOpenRealizationByMonth = true;
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          this.isLoading = false;
          // Sembunyikan loading setelah request selesai
          store.dispatch("hideLoading");
        });
    },

    async openDialogExcel(item) {
      this.selectedRealizationExcel = item;
      this.isDialogExcel = true;
    },

    getStatusColor(status) {
      if (!status) return "default";

      const s = status.toLowerCase();

      if (s.includes("approved")) return "success";

      switch (s) {
        case "pending":
          return "warning";
        case "success":
          return "success";
        case "cancel":
          return "grey";
        case "rejected":
          return "error";
        case "need to analysis":
          return "orange";
        default:
          return "default";
      }
    },

    debouncedSearch() {
      this.updateQuery("search", this.pagination.search);
    },
    updatePagination(query) {
      // console.log(query);
      this.pagination.page = parseInt(query.page) || 1;
      this.pagination.itemsPerPage = parseInt(query.itemsPerPage) || 5;
      this.pagination.sortBy = query.sortBy || "id";
      this.pagination.sortDesc = query.sortDesc === "true" ? true : false;
      this.pagination.search = query.search || this.pagination.search || "";
      this.pagination.startDate = query.startDate || this.pagination.startDate;
      this.pagination.endDate = query.endDate || this.pagination.endDate;
      parseInt(query.worksheet) || this.pagination.worksheet;
      this.pagination.departement_id =
        parseInt(query.departementId) || this.pagination.departement_id;
      this.pagination.year = parseInt(query.year) || this.pagination.year;
      this.pagination.site_id =
        parseInt(query.siteId) || this.pagination.site_id;
      this.pagination.corporate_id =
        parseInt(query.corporateId) || this.pagination.corporate_id;
    },
    updateQuery(key, value) {
      if (this.$route.query[key] !== value) {
        this.$router
          .push({
            query: {
              ...this.$route.query,
              [key]: value, // Mengupdate parameter query dengan key dan value
            },
          })
          .catch((err) => {
            // Handle error jika ada (contohnya, karena navigasi yang redundant)
            if (err.name !== "NavigationDuplicated") {
              console.error(err);
            }
          });
      }
      this.updatePagination(this.$route.query);
    },

    onYearChange() {
      this.fetchParameter();
      this.updateQuery("year", this.pagination.year); // Update endDa
    },

    onWorksheetChange() {
      this.updateQuery("worksheet", this.pagination.worksheet); // Update endDate
    },

    onsiteChange() {
      // this.fetch();
      this.updateQuery("siteId", this.pagination.site_id); // Update endDate
    },

    oncorporateChange() {
      // this.fetch();
      this.updateQuery("corporateId", this.pagination.corporate_id); // Update endDate
    },

    getItemTotalQty(item) {
      return this.months.reduce((total, month) => {
        // console.log(Number(item[`${month.key}_qty`]));
        return total + Number(item[`${month.key}_qty`] || 0);
      }, 0);
    },
    getItemTotalPrice(item) {
      return this.months.reduce((total, month) => {
        return total + Number(item[`${month.key}_total_price`] || 0);
      }, 0);
    },

    getTrend(value) {
      const num = Number(value || 0);

      if (num > 0) return "up";
      if (num < 0) return "down";
      return "flat";
    },

    async exportToExcel() {
      // Tampilkan loading
      store.dispatch("showLoading");
      this.isLoading = true;
      const query = this.$route.query;

      const params = {
        page: 1,
        limit: -1,
        search: query.search || this.pagination.search,
        sortBy: query.sortBy || this.pagination.sortBy || "id",
        sortDesc: query.sortDesc || this.pagination.sortDesc || false,
        status: query.status || this.pagination.status || "all",
        statusOs: query.statusOs || this.pagination.statusOs || "all",
        siteId: query.siteId || this.pagination.siteId || "all",
        startDate: query.startDate || this.pagination.startDate,
        endDate: query.endDate || this.pagination.endDate,
      };

      await api
        .get("/report/budget", { params })
        .then(({ data }) => {
          const dataExcel = data.data.data;

          // Buat workbook dan worksheet
          const workbook = new exceljs.Workbook();
          const worksheet = workbook.addWorksheet("Data Export");

          // Tambahkan header ke worksheet
          const headerRow = this.exportColumns.map((col) => col.label);
          worksheet.addRow(headerRow);

          // Tambahkan data ke worksheet
          dataExcel.forEach((item) => {
            worksheet.addRow(this.exportColumns.map((col) => item[col.key]));
          });

          // Styling header (Bold + Background Color + Center)
          worksheet.getRow(1).eachCell((cell) => {
            cell.font = { bold: true };
            cell.alignment = { horizontal: "center", vertical: "middle" };
            cell.fill = {
              type: "pattern",
              pattern: "solid",
              fgColor: { argb: "FFFF00" }, // Kuning
            };
          });

          // Styling semua sel agar center
          worksheet.eachRow((row) => {
            row.eachCell((cell) => {
              cell.alignment = { horizontal: "center", vertical: "middle" };
            });
          });

          // Auto width untuk setiap kolom
          worksheet.columns.forEach((column) => {
            let maxLength = 0;
            column.eachCell({ includeEmpty: true }, (cell) => {
              maxLength = Math.max(
                maxLength,
                cell.value ? cell.value.toString().length : 10,
              );
            });
            column.width = maxLength + 2; // Tambahkan padding
          });

          // Simpan file Excel
          workbook.xlsx.writeBuffer().then((buffer) => {
            const blob = new Blob([buffer], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            saveAs(
              blob,
              `Report_status_(${dateFormatDmy(
                this.pagination.startDate,
              )}_sampai_${dateFormatDmy(this.pagination.endDate)}).xlsx`,
            );
          });
        })
        .catch((error) => {
          console.error("Error fetching suggestion:", error);
        })
        .finally(() => {
          this.isLoading = false;
          // Sembunyikan loading setelah request selesai
          store.dispatch("hideLoading");
        });
    },
  },
  watch: {
    pagination: {
      handler: "fetch",
      deep: true, // Memastikan perubahan dalam objek pagination terdeteksi
    },
  },
  async mounted() {
    store.commit("setTitle", "Report Budget");

    await Promise.all([
      this.fetchParameter(),
      this.fetchWorksheet(),
      this.fetchPurchaseFrequency(),
      this.fetchItem(),
      this.fetchCoa(),
      this.fetchdepartement(),
      this.fetchSite(),
      this.fetchCorporate(),
      this.fetchSupplier(),
      this.fetchUom(),
      this.updatePagination(this.$route.query),
    ]);

    await this.fetch();
  },

  computed: {
    tableHeaders() {
      return [
        {
          text: "Departement",
          align: "center",
          value: "mst_division_name",
          width: "80px",
        },
        { text: "Bagian", align: "center", value: "part", width: "80px" },

        {
          text: "Jan",
          align: "center",
          value: "january_total_price",
          width: "80px",
        },
        {
          text: "Feb",
          align: "center",
          value: "february_total_price",
          width: "80px",
        },
        {
          text: "Mar",
          align: "center",
          value: "march_total_price",
          width: "80px",
        },
        {
          text: "April",
          align: "center",
          value: "april_total_price",
          width: "80px",
        },
        {
          text: "Mei",
          align: "center",
          value: "may_total_price",
          width: "80px",
        },
        {
          text: "Jun",
          align: "center",
          value: "june_total_price",
          width: "80px",
        },
        {
          text: "Jul",
          align: "center",
          value: "july_total_price",
          width: "80px",
        },
        {
          text: "Agu",
          align: "center",
          value: "august_total_price",
          width: "80px",
        },
        {
          text: "Sep",
          align: "center",
          value: "september_total_price",
          width: "80px",
        },
        {
          text: "Okt",
          align: "center",
          value: "october_total_price",
          width: "80px",
        },
        {
          text: "Nov",
          align: "center",
          value: "november_total_price",
          width: "80px",
        },
        {
          text: "Des",
          align: "center",
          value: "december_total_price",
          width: "80px",
        },
        {
          text: `Budget ${this.pagination.year} (Bulan 1 - 12)`,
          align: "center",
          value: "yearly_total_price",
          class: "header-total",
          width: "135px",
        },
        {
          text: `Realisasi ${this.pagination.year - 1} (Bulan 1 - ${Number(
            this.cut_off_yesterday,
          )})`,
          align: "center",
          value: "yearly_total_price_realization",
          class: "header-total2",
          width: "135px",
        },
        {
          text: `Budget ${this.pagination.year - 1} (Bulan ${
            Number(this.cut_off_yesterday) + 1
          } - 12)`,
          align: "center",
          value: "yearly_total_price_prev",
          class: "header-total2",
          width: "130px",
        },
        {
          text: `Total ${this.pagination.year - 1}`,
          align: "center",
          value: "yearly_total_price_realization_yearly_total_price_prev",
          class: "header-total2",
          width: "120px",
        },
        {
          text: `Kenaikan / Penurunan ${this.pagination.year} vs ${
            this.pagination.year - 1
          }`,
          align: "center",
          value: "naik_turun",
          class: "header-total3",
          width: "160px",
        },
        {
          text: `Kenaikan / Penurunan ${this.pagination.year} vs ${
            this.pagination.year - 1
          } (%)`,
          align: "center",
          value: "naik_turun_percent",
          class: "header-total3",
          width: "160px",
        },
      ];
    },

    user() {
      return store.getters["user/getUser"] || {};
    },
    title() {
      return store.state.title;
    },
    isQty() {
      return this.showMode === "qty" || this.showMode === "all";
    },

    isValues() {
      return this.showMode === "values" || this.showMode === "all";
    },

    filteredListDetailByMonth() {
      const keyword = (this.searchDetail || "").toLowerCase().trim();

      // console.log(this.searchDetail);

      if (!keyword) return this.listDetailByMonth;

      return this.listDetailByMonth.filter(
        (item) =>
          item.item_name?.toLowerCase().includes(keyword) ||
          item.material_name?.toLowerCase().includes(keyword) ||
          item.spesification?.toLowerCase().includes(keyword) ||
          item.uom_name?.toLowerCase().includes(keyword),
      );
    },

    tableHeadersEachItemFilteredByMonth() {
      return this.tableHeadersEachItemByMonth.filter((header) => {
        if (!header.type) return true;

        if (this.showModeByMonth === "qty") {
          return header.type === "qty";
        }

        if (this.showModeByMonth === "values") {
          return header.type === "values";
        }

        return true;
      });
    },

    totalBudget() {
      return this.listDetail.reduce(
        (total, item) => total + Number(item.yearly_total_price || 0),
        0,
      );
    },
  },
};
</script>

<style scoped>
.custom-autocomplete .v-field__input {
  font-size: 8px !important;
}

.custom-autocomplete .v-list-item-title {
  font-size: 8px !important;
}

.v-data-table thead th {
  text-align: center;
  vertical-align: middle;
}

.custom-table th,
.custom-table td {
  white-space: nowrap;
}

.table-wrapper table th,
.table-wrapper table td {
  white-space: nowrap;
}

.no-wrap-table td,
.no-wrap-table th {
  white-space: nowrap;
}

.sticky-excel {
  position: sticky;
  right: 0px;
  background: white;
  z-index: 2;
}

.sticky-action {
  position: sticky;
  right: 0;
  background: white;
  z-index: 3;
}

.month-input {
  width: 75px;
}

.month-input :deep(.v-field) {
  min-height: 34px !important;
  border-radius: 8px !important;
}

.month-input :deep(.v-field__input) {
  min-height: 34px !important;
  padding: 0 8px !important;
}

.month-input :deep(input) {
  text-align: center;
  font-size: 13px;
  font-weight: 500;
}

.budget-table {
  font-size: 13px;
}

.budget-table :deep(thead th) {
  background: #f5f7fa;
  font-weight: 600;
  white-space: nowrap;
}

.month-input {
  min-width: 90px;
}

.month-input :deep(input) {
  text-align: center;
}

.sticky-realization {
  position: sticky;
  left: 0;
  z-index: 2;
  background: white;
}

.sticky-action {
  position: sticky;
  right: 0;
  z-index: 2;
  background: white;
}

.v-card-title {
  min-height: 90px;
}

.dialog-header {
  position: relative;
  background: #fff;
}

.close-btn {
  position: absolute;
  top: 16px;
  right: 16px;
  z-index: 10;
}

.grand-total-row {
  font-weight: bold;
}

.table-wrapper {
  overflow-x: auto;
}

.v-data-table th {
  white-space: nowrap !important;
}

.v-data-table th {
  vertical-align: middle !important;
  white-space: nowrap !important;
}

::v-deep th.header-total {
  background: #f2dbb2 !important;
  color: #ea7712 !important;
}

::v-deep th.header-total2 {
  background: #e3f2fd !important;
  color: #1565c0 !important;
}

::v-deep th.header-total3 {
  background: #c3e8bf !important;
  color: #576e3b !important;
}

.new-item-row {
  background-color: #b3e2bd !important;
  border-left: 4px solid #2e7d32;
}

.new-item-row:hover {
  background-color: #63c376 !important;
}

.clickable-cell {
  width: 100%;
  /* padding: 4px 8px; */
  cursor: pointer;
  border-radius: 4px;
  transition: background-color 0.2s, color 0.2s;
}

.clickable-cell:hover {
  background: #f5f5f5;
  color: #1976d2;
}
</style>
